import { TweenLite } from "gsap";
import { Button } from "../../IO";
import { CreateElement, Scale, SetStyles } from "../../MyHelpers";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import { Settings } from "../../Settings";
import { TranslatorView } from "../../TranslatorView";
import { ZIndex } from "../../ZIndex";
import { PanelParams } from "./IPanelFactory";
import { ButtonState, Panel } from "./panel";
import { Orientation } from "../../FitScreen";
import { TranslatedLocation } from "../../Translator";

export class PanelOnlineResponsive extends Panel {
    private languageView: TranslatorView = null;
    protected spinArrow: ImageResource = null;
    protected spinArrowDiv: HTMLElement;
    protected gamePath: string = "";

    protected responsiveView: HTMLElement

    public constructor(params: PanelParams) {
        super(params);

        this.backendSettings = params.backendSettings;
        this.resid = params.resid.Add("Panel-OnlineResponsive");
        this.resourcesBasePath = params.resourcesBasePath;
        this.audio = params.audio;
        this.translator = params.translator;

        this.systemContext = params.systemContext.CreateSubContext("Panel");

        this.idleAnim = this.systemContext.TimingContext().CreateInterval("idleAnim", 500, () => this.IdleAnim())
        this.languageView = new TranslatorView(this.resid);
        this.gamePath = Settings.ResourcesFolder + "multigame/slot/common/resources/";
    }



    public override SetMessage(message: string): void {
        //this.view.querySelector(".message").innerHTML = message;
        this.messageElem.textContent = message;
    }


    protected buttonBorder: Partial<CSSStyleDeclaration> = {
        border: `${Scale.XYpx(4)} solid gold`,
    };

    protected autoplayButtonBorder: Partial<CSSStyleDeclaration> = {
        border: `${Scale.XYpx(4)} solid red`,
    };


    private linesMessage: TranslatedLocation;
    public override ConstructHtml() {

        let cssLinear: Partial<CSSStyleDeclaration> = {
            borderWidth: Scale.XYpx(5),
            borderStyle: "solid",
            position: "relative",
            margin: "0px auto",
            bottom: Scale.Ypx(5),
            filter: `blur(${Scale.XYpx(2)})`,
            width: "80%",
            borderImage: this.ButtonBackground().linearColor
        };

        let cssVerticalGroup: Partial<CSSStyleDeclaration> = {
            display: "flex",
            flexDirection: "column",
            //justifyContent: "flex-end",
        };

        let cssHorizontalGroup: Partial<CSSStyleDeclaration> = {
            display: "flex",
            flexDirection: "row",
            flexGrow: "1",
        };

        let cssLeftRightButton: Partial<CSSStyleDeclaration> = {
            flexGrow: "1",
            height: Scale.Hpx(100),
            width: Scale.Wpx(70),
        };

        let cssMenuInfoButton: Partial<CSSStyleDeclaration> = {
            flexGrow: "1",
            height: Scale.Hpx(40),
            width: Scale.Wpx(70),
        };

        let cssButton: Partial<CSSStyleDeclaration> = {
            borderRadius: Scale.XYpx(16),

            border: `${Scale.XYpx(4)} solid gold`,
            //backgroundClip: "padding-box",
            borderStyle: "inset",

            margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
            height: Scale.Hpx(100),

            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",

            //backgroundOrigin: "border-box",
            //backgroundClip: "content-box, border-box",
            background: "rgba(0, 0, 0,0.5)",
        };

        let cssLabel: Partial<CSSStyleDeclaration> = {
            fontSize: Scale.fhpx(20),
            lineHeight: "0px",
            //color: "white",
            textAlign: "center",

            fontFamily: "NotoSansDisplay-Bold",
            fontWeight: "bold",
            color: "white",
            textShadow: Array(Math.round(Scale.XY(18))).fill("#001 0px 0px 4px").join(", ") //.repeat() #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
        };

        let cssMessageValue: Partial<CSSStyleDeclaration> = {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: Scale.fhpx(20),

            color: "white",
            textShadow: "0 0 10px black",
            background: "transparent",
        };
        //credits
        let cssCredit: Partial<CSSStyleDeclaration> = {
            fontSize: Scale.fhpx(35),
            lineHeight: Scale.Hpx(40),
            textAlign: "center",
            height: "100%",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            color: "white",
            top: Scale.Ypx(25),
            textShadow: `0 0 ${Scale.XYpx(10)} black`,

        };
        //money
        let cssCurrency: Partial<CSSStyleDeclaration> = {
            fontSize: Scale.fhpx(20),
            textAlign: "center",
            color: "yellow",
            textShadow: `0 0 ${Scale.XYpx(10)} black`,
            position: "relative",
            top: Scale.Ypx(14),
            left: Scale.Ypx(0),
            margin: Scale.Ypx(0),

        }

        // /* #region Left column */
        // let leftCol = CreateElement("div", {
        //     classes: ["but-vertical-group", "but-group-value-collect"],
        //     parentToAppend: this.view,
        //     style: {
        //         ...cssVerticalGroup
        //     }
        // });

        //     this.butVolume = CreateElement("div", {
        //         classes: ["but-vol", "button"],
        //         parentToAppend: leftCol,
        //         style: {
        //             ...cssLeftRightButton,
        // 			...cssButton,
        // 			//borderRadius: Scale.XYpx(50),

        //         }
        //     });

        //         let butVolLabel = CreateElement("div", {
        //             classes: ["but-vol-value", "label"],
        //             parentToAppend: this.butVolume,
        //             style: {
        //                 ...cssLabel
        //             }
        //         });

        //     this.butDenom = CreateElement("div", {
        //         classes: ["but-denom", "button"],
        //         parentToAppend: leftCol,
        //         style: {
        //             ...cssLeftRightButton,
        //             ...cssButton
        //         }
        //     });

        //         this.denomElem = CreateElement("div", {
        //             classes: ["denom-value", "message-value"],
        //             parentToAppend: this.butDenom,
        //             style: {
        //                 ...cssMessageValue
        //             }
        //         });

        //             let butDenomDenom = CreateElement("div", {
        //                 classes: ["denom-denom"],
        //                 parentToAppend: this.denomElem
        //             });


        /* #endregion */

        //this.view.innerHTML += 
        // `
        // <!-- new panel -->
        // <div class="but-vertical-group but-group-value-collect">
        //     <div class="but-vol button">
        //         <span class="but-vol-value label">
        //         </span>
        //     </div>

        //     <!--
        //     <div class="but-collect button">
        //         <span class="but-collect-value label">COLLECT</span>
        //     </div>
        //     -->
        //     <div class="but-denom button">
        //         <div class="denom-value message-value"><span class="denom-denom"></span></div>
        //     </div>
        // </div>`


        // `<div class="but-horizontal-group but-left-group">
        //     <div class="but-vertical-group but-group-denom-balance">


        //         <div class="but-credit button">
        //             <div class="but-credit-label label">

        //             </div>
        //             <div class="but-credit-currency currency">
        //                 <span class="but-credit-currency-value">123,456.00</span>
        //                 <!--<span class="but-credit-currncy-icon"></span>-->
        //             </div>
        //             <div class="but-credit-credit credit">123456</div>

        //             <div class="linear"> </div>
        //         </div>
        //     </div>

        //     <div class="but-vertical-group but-group-lines-totalbet">
        //         <div class="but-lines button " style="border: hidden; box-shadow: none;">
        //             <div class="but-lines-value message-value"><span class="playinon"> </span>&nbsp;<span
        //                     class="selected-lines"></span>&nbsp;
        //                 <span class="lines"></span></div>
        //         </div>

        //         <div class="but-horizontal-group">

        //             <div class="but-totalbet button">

        //                 <div class="but-totalbet-label label"></div>
        //                 <div class="but-totalbet-currency currency">
        //                     <span class="but-totalbet-currency-value">123.00</span>
        //                     <!--<span class="but-totalbet-currency-symbol"></span>-->
        //                 </div>

        //                 <div class="but-totalbet-credit credit">123</div>
        //                 <div class="linear"> </div>

        //             </div>

        //             <div class="but-betperline button" style="visibility: hidden;">
        //                 <div class="but-betperline-label label"></div>
        //                 <div class="but-betperline-credit credit">123</div>
        //                 <div class="but-betperline-currency currency">
        //                     <span class="but-betperline-currency-value">123.00</span>
        //                     <!--<span class="but-betperline-currency-symbol"></span>-->
        //                 </div>
        //             </div>
        //         </div>
        //     </div>


        // </div>`;

        // LEFT GROUP
        let grpLeft = CreateElement("div", {
            classes: ["but-vertical-group", "but-left-group"], parentToAppend: this.view, style: {
                ...cssVerticalGroup,
                //width: "100%"
            }
        });
        let btnLines = CreateElement("div", {
            classes: ["but-lines", "button"], parentToAppend: grpLeft, style: {
                height: Scale.Hpx(35),
                //position: "relative",
                //left: "-224px",
                //background: "transparent",
                //...cssButton
                alignSelf: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }
        });

        this.linesDenomMessage = this.translator.Translate(() => this.translator.t.playingOnLines(this.lines));
        let btnLinesValue = CreateElement("div", {
            classes: ["but-lines-value", "message-value"],
            parentToAppend: btnLines,
            childToAppend: this.linesDenomMessage.location,
            style: {
                ...cssMessageValue
            }
        });

        let grpDenomBalance = CreateElement("div", {
            classes: ["but-horizontal-group", "but-group-denom-balance"], parentToAppend: grpLeft, style: {
                ...cssHorizontalGroup,
                //flexGrow: "1"
                justifyContent: "space-evenly",
            }
        });
        this.btnBalance = CreateElement("div", {
            classes: ["but-credit", "button"], parentToAppend: grpDenomBalance, style: {
                position: "relative",
                alignSelf: "flex-end",
                //left: "80px",
                width: Scale.Wpx(220),
                ...cssButton
            }
        });
        let btnBalanceLabel = CreateElement("div", {
            classes: ["but-credit-label", "label"],
            parentToAppend: this.btnBalance,
            childToAppend: this.translator.Anchor(() => this.translator.t.balance),
            style: {
                ...cssLabel
            }
        });

        this.balanceCurrency = CreateElement("div", {
            classes: ["but-credit-currency", "currency"], parentToAppend: this.btnBalance, style: {
                ...cssCurrency
            }
        });
        let btnBalanceCurrencyValue = CreateElement("span", { classes: ["but-credit-currency-value"], parentToAppend: this.balanceCurrency, innerHTML: "123,456.00" });
        this.balanceCredits = CreateElement("div", {
            classes: ["but-credit-credit", "credit"], parentToAppend: this.btnBalance, innerHTML: "123456", style: {
                ...cssCredit
            }
        });
        let btnBalanceLinear = CreateElement("div", {
            classes: ["linear"], parentToAppend: this.btnBalance, style: {
                ...cssLinear
            }
        });

        // let grpLinesTotalbet = CreateElement("div", {classes: ["but-vertical-group", "but-group-lines-totalbet"], parentToAppend: grpLeft, style: {
        //     ...cssVerticalGroup,
        //     justifyContent: "space-evenly"
        // }});

        // TODO some spans, not needed 
        // let grpTotalPerLine = CreateElement("div", {classes: ["but-horizontal-group"], parentToAppend: grpDenomBalance, style: {
        //     ...cssHorizontalGroup
        // }});

        {
            let butDenom = CreateElement("div", {
                classes: ["but-denom", "button"], parentToAppend: grpDenomBalance, style: {
                    //alignSelf: "flex-end",
                    //flexGrow: "1",
                    alignSelf: "flex-end",
                    position: "relative",
                    //left: "127px",
                    width: Scale.Wpx(122),
                    ...cssButton
                }
            });
            this.butDenom = butDenom;
            let butDenomLabel = CreateElement("div", {
                classes: ["but-denom-label", "label"],
                parentToAppend: butDenom,
                childToAppend: this.translator.Anchor(() => this.translator.t.denom),
                style: {
                    ...cssLabel
                }
            });
            this.totalBetCurrency = CreateElement("div", {
                classes: ["but-denom-currency", "currency"], parentToAppend: butDenom, childToAppend: this.translator.Anchor(() => this.translator.t.denomOneCredit), style: {
                    ...cssCurrency
                }
            });
            // TODO span
            this.denomElem = CreateElement("div", {
                classes: ["but-denom-credit", "credit"], parentToAppend: butDenom, innerHTML: "123", style: {
                    ...cssCredit
                }
            });
            let butDenomLinear = CreateElement("div", {
                classes: ["linear"], parentToAppend: butDenom, style: {
                    ...cssLinear
                }
            });
        }


        {
            let btnTotalbet = CreateElement("div", {
                classes: ["but-totalbet", "button"], parentToAppend: grpDenomBalance, style: {
                    //alignSelf: "flex-end",
                    //flexGrow: "1",
                    alignSelf: "flex-end",
                    position: "relative",
                    //left: "127px",
                    width: Scale.Wpx(122),
                    ...cssButton
                }
            });
            this.butTotalBet = btnTotalbet;
            let btnTotalbetLabel = CreateElement("div", {
                classes: ["but-totalbet-label", "label"],
                parentToAppend: btnTotalbet,
                childToAppend: this.translator.Anchor(() => this.translator.t.tbet),
                style: {
                    ...cssLabel
                }
            });
            this.totalBetCurrency = CreateElement("div", {
                classes: ["but-totalbet-currency", "currency"], parentToAppend: btnTotalbet, innerHTML: "123.00", style: {
                    ...cssCurrency
                }
            });
            // TODO span
            this.totalBetCredits = CreateElement("div", {
                classes: ["but-totalbet-credit", "credit"], parentToAppend: btnTotalbet, innerHTML: "123", style: {
                    ...cssCredit
                }
            });
            let btnTotalbetLinear = CreateElement("div", {
                classes: ["linear"], parentToAppend: btnTotalbet, style: {
                    ...cssLinear
                }
            });

            let btnPerLine = CreateElement("div", {
                classes: ["but-betperline", "button"],
                parentToAppend: grpDenomBalance,
                style: {
                    alignSelf: "flex-end",
                    flexGrow: "1",
                    ...cssButton,
                    display: "none",
                }
            });
            let btnPerLineLabel = CreateElement("div", {
                classes: ["but-betperline-label", "label"],
                parentToAppend: btnPerLine,
                childToAppend: this.translator.Anchor(() => this.translator.t.tline),
                style: {
                    ...cssLabel
                }
            });
            this.betCredits = CreateElement("div", {
                classes: ["but-betperline-credit", "credit"],
                parentToAppend: btnPerLine,
                innerHTML: "123",
                style: {
                    ...cssCredit
                }
            });
            this.betCurrency = CreateElement("div", {
                classes: ["but-betperline-currency", "currency"],
                parentToAppend: btnPerLine,
                style: {
                    ...cssCurrency
                }
            });
            // TODO span
        }

        //this.butTotalBet = this.view.querySelector(".but-totalbet");

        // this.view.innerHTML += `<div class="but-vertical-group">

        //     <div class="but-win button">
        //         <div class="but-win-label label"></div>
        //         <div class="but-win-currency currency">
        //             <span class="but-win-currency-value">123,456.00</span>
        //             <!--<span class="but-win-currncy-icon">MXN</span>-->
        //         </div>
        //         <div class="but-win-credit credit">999999</div>
        //         <div class="linear"></div>
        //     </div>
        // </div>`;



        let centerCol = CreateElement("div", {
            classes: ["but-vertical-group"],
            parentToAppend: this.view,
            style: {
                ...cssVerticalGroup,
            }
        });

        let butWin = CreateElement("div", {
            classes: ["but-win", "button"],
            parentToAppend: centerCol,
            style: {
                position: "relative",
                ...cssButton,
                minWidth: Scale.Wpx(480),
                flexGrow: "1",
            }
        });

        this.freeRoundsRemainingText = this.translator.Translate(() => {

            let remaining = 0;
            
            if (this.freeRoundsStats)
            {
                remaining = this.freeRoundsStats.FreeRoundsNumber - this.freeRoundsStats.PlayedFreeRoundsNumber;
            }

            return this.translator.t.freerRoundCounterText(remaining)
        });

        this.freeRoundsRemaining = CreateElement("div", {
            classes: ["free-spins-remaining", "label"],
            parentToAppend: butWin,
            childToAppend: this.freeRoundsRemainingText.location,
            style: {
                fontSize: Scale.fhpx(30),
                lineHeight: "0px",
                position: "absolute",
                top: "-15px",
                alignSelf: "center",
                display:"none",
                //borderRadius: Scale.XYpx(16),

                //border: `${Scale.XYpx(4)} solid gold`,
                //borderStyle: "inset",

                margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
                color: "white",

            }
        });


        let butWinLabel = CreateElement("div", {
            classes: ["but-win-label", "label"],
            parentToAppend: butWin,
            style: {
                fontSize: Scale.fhpx(30),
                lineHeight: "0px",
                ...cssLabel
            }
        });

        this.winCurrency = CreateElement("div", {
            classes: ["but-win-currency", "currency"],
            parentToAppend: butWin,
            style: {
                fontSize: Scale.fhpx(35),
                textAlign: "center",
                color: "yellow",
                textShadow: "0 0 10px black",
                position: "relative",
                top: Scale.Ypx(30),
            }
        });

        // let butWinCurrencyValue = CreateElement("span", {
        //     classes: ["but-win-currency-value"],
        //     parentToAppend: butWinCurrency
        // });

        this.winCredits = CreateElement("div", {
            classes: ["but-win-credit", "credit"],
            parentToAppend: butWin,
            style: {
                ...cssCredit,
                fontSize: Scale.fhpx(65),
                lineHeight: Scale.Hpx(100),
                marginTop: Scale.Ypx(2),
            }
        });

        let butWinLinear = CreateElement("div", {
            classes: ["linear"],
            parentToAppend: butWin,
            style: {
                ...cssLinear,
                bottom: Scale.Ypx(14),

            }
        });



        // this.view.innerHTML += `
        // <div class="but-vertical-group but-group-autplay-maxbet-spin-messages but-right-group">
        //     <div class="but-message button message-value message" style="border: hidden; box-shadow: none;">
        //     </div>

        //     <div class="but-horizontal-group but-group-autoplay-maxbet-spin">
        //         <div class="but-horizontal-group but-group-autoplay-maxbet">
        //             <div class="but-auto-play button" style="visibility: hidden;">
        //                 <div class="but-auto-play-label label"></div>
        //             </div>

        //             <div class="but-max-bet button" style="position: relative; left: -100px;">
        //                 <div class="but-max-bet-label label"></div>
        //                 <div class="linear"> </div>
        //             </div>
        //         </div>


        //         <div class="but-spin button ">
        //             <div id="spindix" class="but-spin-label label"></div>
        //             <div class="linear"> </div>
        //         </div>
        //     </div>
        // </div>`;

        let grpRight = CreateElement("div", {
            classes: ["but-vertical-group", "but-group-autplay-maxbet-spin-messages", "but-right-group"],
            parentToAppend: this.view,
            style: {
                ...cssVerticalGroup,
                //width: "100%",
            }
        });

        this.messageElem = CreateElement("div", {
            classes: ["but-message", "button", "message-value", "message"],
            parentToAppend: grpRight,
            style: {
                height: Scale.Hpx(35),
                position: "relative",
                //left: "-30px",
                //...cssButton,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: Scale.fhpx(20),
                color: "white",
                textShadow: `0 0 ${Scale.XYpx(10)} black`,
                background: "transparent",
            }
        });

        let grpRightHorizontal = CreateElement("div", {
            classes: ["but-horizontal-group", "but-group-autoplay-maxbet-spin"],
            parentToAppend: grpRight,
            style: {
                ...cssHorizontalGroup,
                flexGrow: "1",
                justifyContent: "space-evenly",
            }
        });

        let grpAutoplayMaxbet = CreateElement("div", {
            classes: ["but-horizontal-group", "but-group-autoplay-maxbet"],
            parentToAppend: grpRightHorizontal,
            style: {
                ...cssHorizontalGroup,
                flexGrow: "0",
            }
        });

        // this.butAutoplay = CreateElement("div", 
        //     {
        //         classes: ["but-auto-play", "button"],
        //         parentToAppend: grpAutoplayMaxbet,
        //         style: {
        //             //flexGrow: "1",
        //             alignSelf: "flex-end",
        //             ...cssButton,
        //             //display: "none",
        //         }
        //     });

        // let butAutplayLabel = CreateElement("div", 
        //         {
        //             classes: ["but-auto-play-label", "label"],
        //             parentToAppend: this.butAutoplay,
        //             childToAppend: this.translator.Anchor(() => this.translator.t.auto),
        //             style: {
        //                 ...cssLabel,
        //                 fontSize: Scale.fhpx(18),

        //             }
        //         });

        this.butMaxBet = CreateElement("div", {
            classes: ["but-max-bet", "button"],
            parentToAppend: grpAutoplayMaxbet,
            style: {
                //flexGrow: "1",
                alignSelf: "flex-end",
                ...cssButton,
                width: Scale.Wpx(120),
            }
        })

        let butMaxBetLabel = CreateElement("div", {
            classes: ["but-max-bet-label", "label"],
            parentToAppend: this.butMaxBet,
            childToAppend: this.translator.Anchor(() => this.translator.t.maxbet),
            style: {
                ...cssLabel,
                lineHeight: Scale.Hpx(20),
                textAlign: "center",
                color: "white",
                position: "relative",
                top: Scale.Ypx(10),
            }
        });

        let butMaxBetLinear = CreateElement("div", {
            classes: ["linear"],
            parentToAppend: this.butMaxBet,
            style: {
                ...cssLinear,
                top: Scale.Ypx(12),
            }
        });


        this.butAutoplay = CreateElement("div",
            {
                classes: ["but-auto-play", "button"],
                parentToAppend: grpAutoplayMaxbet,
                style: {
                    //flexGrow: "1",
                    alignSelf: "flex-end",
                    ...cssButton,
                    //display: "none",
                    width: Scale.Wpx(122),

                }
            });

        let butAutplayLabel = CreateElement("div",
            {
                classes: ["but-auto-play-label", "label"],
                parentToAppend: this.butAutoplay,
                childToAppend: this.translator.Anchor(() => this.translator.t.auto),
                style: {
                    ...cssLabel,
                    //fontSize: Scale.fhpx(18),
                    lineHeight: Scale.Hpx(20),
                    textAlign: "center",
                    color: "white",
                    position: "relative",
                    top: Scale.Ypx(10),


                }
            });

        let butAutoLinear = CreateElement("div", {
            classes: ["linear"],
            parentToAppend: this.butAutoplay,
            style: {
                ...cssLinear,
                textAlign: "center",
                top: Scale.Ypx(12),
            }
        });




        // +
        // `<div class="but-vertical-group but-group-help-games">
        //     <div class="but-help button">
        //         <div class="help-background">
        //             <div class="but-help-icon label">INFO</div>
        //         </div>
        //     </div>


        //     <div class="but-games button">
        //         <span class="but-games-icon label">MENU</span>
        //     </div>
        // </div>
        // // `
        // ;
        // {
            let rightCol = CreateElement("div", {
                classes: ["but-vertical-group", "but-group-help-games"],
                parentToAppend: this.view,
                style: {
                    ...cssVerticalGroup
                }
            });
        this.butVolume = CreateElement("div", {
            classes: ["but-vol", "button"],
            parentToAppend: rightCol,
            style: {
                ...cssLeftRightButton,
                ...cssButton,
                //borderRadius: Scale.XYpx(50),

            }
        });
        this.butVolLabel = CreateElement("div", {
            classes: ["but-vol-value", "label"],
            parentToAppend: this.butVolume,
            style: {
                ...this.cssLabel
            }
        });

        {
            let rightCol = CreateElement("div", {
                classes: ["but-vertical-group", "but-group-help-games"],
                parentToAppend: this.view,
                style: {
                    ...cssVerticalGroup
                }
            });
            this.butHelp = CreateElement("div", {
                classes: ["but-help", "button"],
                parentToAppend: rightCol,
                style: {
                    ...cssButton,
                    ...cssMenuInfoButton,
                }
            });

            let butHelpBack = CreateElement("div", {
                classes: ["help-background"],
                parentToAppend: this.butHelp
            });

            let butHelpLabel = CreateElement("div", {
                classes: ["but-help-icon", "label"],
                parentToAppend: butHelpBack,
                innerHTML: "INFO",
                style: {
                    ...cssLabel
                }
            });

            this.butMenu = CreateElement("div", {
                classes: ["but-games", "button"],
                parentToAppend: rightCol,
                style: {

                    ...cssButton,
                    ...cssMenuInfoButton,
                    overflow: "hidden",
                    display: "block",
                    //flexGrow : "0"
                }
            });


        }



        this.responsiveView = CreateElement("div", {
            classes: ["panel-responsive-view"],
            style: {
                position: "absolute",
                right: "0px",
                top: "0px",
                width: "10%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                zIndex: ZIndex.ResponsivePanel.toString(),
            }
        });

        this.butSpin = CreateElement("div", {
            classes: ["but-spin", "button"],
            parentToAppend: this.responsiveView,
            style: {

                width: "10vw",
                alignSelf: "flex-end",
                position: "relative",
                height: "10vw",
                borderRadius: "50%",
                aspectRatio: "1/1",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                transform: "rotate(90deg)",
                background: `${this.panelColors.backgroundButtonColor}`,
                border: `${Scale.W(16)}px solid gold`,
            }
        });

        this.spinArrowDiv = CreateElement("div", {
            classes: ["but-spin-arrow", "arrow"],
            parentToAppend: this.butSpin,
            style: {
                backgroundImage: this.spinArrow.CssBackground(),
                height: '100%',
                width: '100%',
                position: "absolute",
                placeContent: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
            }
        });
    }
    protected override AnimateButtonPress(buttonState: ButtonState, pressed: boolean): void {
        if (pressed) {
            if (buttonState.button == Button.ButtonSpin && this.spinArrowDiv) {
                TweenLite.fromTo(this.spinArrowDiv, 1, { rotation: 0 }, { rotation: 720 });
                //this.spinCircleSmallArrowDiv.style.backgroundColor="#FF0000";
            }
        }
    }

    protected override IdleAnim() {
    }

    public override async PrepareResources(resourceManager: ResourceManager): Promise<void> {
        super.PrepareResources(resourceManager);
        //Language View
        await this.languageView.PrepareResources(resourceManager);
        resourceManager.Add(new ImageResource(this.gamePath + "arrow.png", this.resid.ScopedResourceName(["arrow", "cycle"])));//New Element
    }

    public override async ResourcesLoaded(resourceManager: ResourceManager): Promise<void> {

        this.spinArrow = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["arrow", "cycle"]));//New Element

        this.view = CreateElement("div", {
            classes: ["panel", this.resid.Scope()],
            style: {

                //border: "5px solid blue",
                boxSizing: "border-box",

                //width: "100%",
                width: Scale.Wpx(1575),
                height: Scale.Hpx(160),

                fontFamily: "NotoSansDisplay-Bold",
                fontWeight: "bold",

                display: "flex",
                justifyContent: "space-between",

                transformOrigin: "bottom",
                zIndex: ZIndex.Panel.toString(),

                //position: "absolute",

            }
        });

        this.ConstructHtml();

        this.ConstructButton(Button.ButtonSpin, this.butSpin);
        this.ConstructButton(Button.ButtonCreditsMoney, this.btnBalance);

        this.ConstructButton(Button.ButtonBetNext, this.butTotalBet);
        this.ConstructButton(Button.ButtonHelp, this.butHelp, 500);
        this.ConstructButton(Button.ButtonVolumeNext, this.butVolume);
        this.ConstructButton(Button.ButtonAutoplay, this.butAutoplay);
        this.ConstructButton(Button.ButtonMaxBet, this.butMaxBet);
        this.ConstructButton(Button.ButtonDenomMenu, this.butDenom, 500);

        this.volume0 = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["volume0", "image"]));
        this.volume1 = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["volume1", "image"]));
        this.volume2 = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["volume2", "image"]));
        this.volume3 = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["volume3", "image"]));


        this.audio.OnVolumeChange((volumeLevel: number, volumeFactor: number) => this.OnVolumeChange(volumeLevel, volumeFactor));

        //language flag
        await this.languageView.ResourcesLoaded(resourceManager);

        this.butMenu.appendChild(this.languageView.View());

        this.AutoPlayLoaded();
    }


    protected override AutoPlayPrepare(): void {
    }

    protected override AutoPlayLoaded() {
        let autoPlayButtonElem = this.butElem.get(Button.ButtonAutoplay);
        if (autoPlayButtonElem) {
            this.autoPlayTimer = this.systemContext.TimingContext().CreateInterval("autoplay", 250, () => {
                if (this.autoPlayColor == "red") {
                    this.autoPlayColor = "transparent";
                    SetStyles(autoPlayButtonElem, this.buttonBorder);
                }
                else {
                    this.autoPlayColor = "red";
                    SetStyles(autoPlayButtonElem, this.autoplayButtonBorder);
                }
            });
        }
    }

    public override AutoplayEnable(): void {
        this.autoPlayTimer?.Start();
    }

    public override AutoplayDisable(): void {
        this.autoPlayTimer?.Stop();
        let autoPlayButtonElem = this.butElem.get(Button.ButtonAutoplay);
        if (autoPlayButtonElem) {
            SetStyles(autoPlayButtonElem, this.buttonBorder);
            //autoPlayButtonElem.style.borderColor = "transparent"
        }

    }
    public override SpinButtonLabelChange(state: string): void { }
    protected override IdleAnimStop() {
        this.idleAnim.Stop();

        // off
        this.idleAnimState = false;
    }

    public ResponsiveView() {
        return this.responsiveView;
    }

    lastOrientation: Orientation = Orientation.Landscape;
    public override OnResize(w: number, h: number, orientation: Orientation) {
        if (orientation != this.lastOrientation) {
            if (orientation == Orientation.Landscape) {
                this.responsiveView.style.left = "";
                this.responsiveView.style.bottom = "";

                this.responsiveView.style.right = "0px";
                this.responsiveView.style.top = "0px";
                this.responsiveView.style.width = "10%";
                this.responsiveView.style.height = "100%";
                this.responsiveView.style.flexDirection = "column";

                this.butSpin.style.width = "10vw";
                this.butSpin.style.height = "10vw";
            }
            else if (orientation == Orientation.Portrait) {
                this.responsiveView.style.right = "";
                this.responsiveView.style.top = "";

                this.responsiveView.style.left = "0px";
                this.responsiveView.style.bottom = "10%";
                this.responsiveView.style.height = "10%";
                this.responsiveView.style.width = "100%";
                this.responsiveView.style.flexDirection = "row";

                this.butSpin.style.width = "10vh";
                this.butSpin.style.height = "10vh";
            }

            this.lastOrientation = orientation;
        }
    }
}
